import React, { PureComponent } from "react";
//import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Nexoid_Agent extends PureComponent {
  render() {
    return (
      <div className="row" id="nexoid_agent">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Nexoid Agent</h2>
              <p>
                Nexoid agent is a small light weight integration tool used to by the Nexoid framework and some modules. Nexoid agent currently supports;
              </p>
              <ul>
                <li>Active Directory Integration</li>
                <li>Single Sign On</li>
                <li>ITSM Incident IMAP</li>
                <li>CMDB Machine Monitor</li>
                <li>System Monitoring</li>
              </ul>
              <h3>Silent Running in Windows</h3>
              <p>The windows executable is designed as a standalone console executable. To make it run in a silent mode you will need to wrap it in either vbs or a powershell script. Below / Right is an example of each.</p>

              <h3 >Nexoid Agent Download</h3>
              <table className="downloadFiles" style={{ marginTop: 8 }}>
                <tbody>
                  <tr className="headerRow">
                    <td></td>
                    <td>File name</td>
                    <td className="d-md-none d-xl-block">Size</td>
                    <td></td>
                  </tr>
                  <tr style={{ height: 72 }}>
                    <td style={{ verticalAlign: "top" }}>
                      <span style={{ margin: 4, display: "block", width: 48, height: 48, padding: 12, backgroundColor: "white", borderRadius: 32 }}>
                        <img style={{ width: 24, height: 24 }} alt="Windows Nexoid Agent" src="/img/os_icons/win.webp" />
                      </span>
                    </td>
                    <td style={{ paddingTop: 10 }}>
                      <strong>NexoidAgent.exe</strong> <br />
                      Windows Agent
                    </td>
                    <td
                      style={{ paddingTop: 24, whiteSpace: "nowrap" }}
                      className="rightAlign d-md-none d-xl-block"
                    >
                      49.9 MB
                    </td>
                    <td style={{ paddingTop: 24, textAlign: "right", paddingRight: 16 }}>
                      <a
                        href={"https://nexoid-data.s3.eu-west-1.amazonaws.com/agent/win/NexoidAgent.exe"}
                        variant="contained"
                        className="rndButton"
                      >
                        Download
                      </a>
                    </td>
                  </tr>
                  <tr className="altRow" style={{ height: 72 }}>
                    <td style={{ verticalAlign: "top" }}>
                      <span style={{ margin: 4, display: "block", width: 48, height: 48, padding: 12, backgroundColor: "white", borderRadius: 32 }}>
                        <img style={{ width: 24, height: 24 }} alt="Linux Nexoid Agent" src="/img/os_icons/linux.webp" />
                      </span>
                    </td>
                    <td style={{ paddingTop: 10 }}>
                      <strong>NexoidAgent</strong><br />
                      Linux Agent
                    </td>
                    <td
                      style={{ paddingTop: 24, whiteSpace: "nowrap" }}
                      className="rightAlign d-md-none d-xl-block"
                    >
                      53.9 MB
                    </td>
                    <td style={{ paddingTop: 24, textAlign: "right", paddingRight: 16 }}>
                      <a
                        href={"https://nexoid-data.s3.eu-west-1.amazonaws.com/agent/linux/NexoidAgent"}
                        variant="contained"
                        className="rndButton"
                      >
                        Download
                      </a>
                    </td>
                  </tr>
                  <tr className="altRow" style={{ height: 72 }}>
                    <td style={{ verticalAlign: "top" }}>
                      <span style={{ margin: 4, display: "block", width: 48, height: 48, padding: 12, backgroundColor: "white", borderRadius: 32 }}>
                        <img style={{ width: 24, height: 24 }} alt="Apple Nexoid Agent" src="/img/os_icons/mac.webp" />
                      </span>
                    </td>
                    <td style={{ paddingTop: 10 }}>
                      <strong>NexoidAgent</strong><br /> Apple Agent
                    </td>
                    <td
                      style={{ paddingTop: 24, whiteSpace: "nowrap" }}
                      className="rightAlign d-md-none d-xl-block"
                    >
                      54 MB
                    </td>
                    <td style={{ paddingTop: 24, textAlign: "right", paddingRight: 16 }}>
                      <a
                        href={"https://nexoid-data.s3.eu-west-1.amazonaws.com/agent/mac/NexoidAgent"}
                        variant="contained"
                        className="rndButton"
                      >
                        Download
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3>Other Tools</h3>
              <table className="downloadFiles" style={{ marginTop: 8 }}>
                <tbody>
                  <tr className="headerRow">
                    <td></td>
                    <td>File name</td>
                    <td className="d-md-none d-xl-block">Size</td>
                    <td></td>
                  </tr>
                  <tr style={{ height: 72 }}>
                    <td style={{ verticalAlign: "top" }}>
                      <span style={{ margin: 4, display: "block", width: 48, height: 48, padding: 12, backgroundColor: "white", borderRadius: 32 }}>
                        <img style={{ width: 24, height: 24 }} alt="Windows Nexoid Agent" src="/img/os_icons/win.webp" />
                      </span>
                    </td>
                    <td style={{ paddingTop: 10 }}>
                      <strong>IntuneWinAppUtil.exe</strong> <br />
                      Create intune deployment packages
                    </td>
                    <td
                      style={{ paddingTop: 24, whiteSpace: "nowrap" }}
                      className="rightAlign d-md-none d-xl-block"
                    >
                      53 KB
                    </td>
                    <td style={{ paddingTop: 24, textAlign: "right", paddingRight: 16 }}>
                      <a
                        href={"https://nexoid-data.s3.eu-west-1.amazonaws.com/agent/win/IntuneWinAppUtil.exe"}
                        variant="contained"
                        className="rndButton"
                      >
                        Download
                      </a>
                    </td>
                  </tr>
                  <tr style={{ height: 72 }}>
                    <td style={{ verticalAlign: "top" }}>
                      <span style={{ margin: 4, display: "block", width: 48, height: 48, padding: 12, backgroundColor: "white", borderRadius: 32 }}>
                        <img style={{ width: 24, height: 24 }} alt="Windows Nexoid Agent" src="/img/os_icons/win.webp" />
                      </span>
                    </td>
                    <td style={{ paddingTop: 10 }}>
                      <strong>NexoidAgentShortcuts.zip</strong> <br />
                      Shortcuts
                    </td>
                    <td
                      style={{ paddingTop: 24, whiteSpace: "nowrap" }}
                      className="rightAlign d-md-none d-xl-block"
                    >
                      50 KB
                    </td>
                    <td style={{ paddingTop: 24, textAlign: "right", paddingRight: 16 }}>
                      <a
                        href={"https://nexoid-data.s3.eu-west-1.amazonaws.com/agent/win/NexoidAgentShortcuts.zip"}
                        variant="contained"
                        className="rndButton"
                      >
                        Download
                      </a>
                    </td>
                  </tr>
                  <tr style={{ height: 72 }}>
                    <td style={{ verticalAlign: "top" }}>
                      <span style={{ margin: 4, display: "block", width: 48, height: 48, padding: 12, backgroundColor: "white", borderRadius: 32 }}>
                        <img style={{ width: 24, height: 24 }} alt="Windows Nexoid Agent" src="/img/os_icons/win.webp" />
                      </span>
                    </td>
                    <td style={{ paddingTop: 10 }}>
                      <strong>SilentCMD.exe</strong> <br />
                      Run Nexoid Agent in background
                    </td>
                    <td
                      style={{ paddingTop: 24, whiteSpace: "nowrap" }}
                      className="rightAlign d-md-none d-xl-block"
                    >
                      14 KB
                    </td>
                    <td style={{ paddingTop: 24, textAlign: "right", paddingRight: 16 }}>
                      <a
                        href={"https://nexoid-data.s3.eu-west-1.amazonaws.com/agent/win/SilentCMD.exe"}
                        variant="contained"
                        className="rndButton"
                      >
                        Download
                      </a>
                    </td>
                  </tr>
                  <tr style={{ height: 72 }}>
                    <td style={{ verticalAlign: "top" }}>
                      <span style={{ margin: 4, display: "block", width: 48, height: 48, padding: 12, backgroundColor: "white", borderRadius: 32 }}>
                        <img style={{ width: 24, height: 24 }} alt="Windows Nexoid Agent" src="/img/os_icons/win.webp" />
                      </span>
                    </td>
                    <td style={{ paddingTop: 10 }}>
                      <strong>SilentCMD.exe.config</strong> <br />
                      Improves SilentCMD.exe compatibility
                    </td>
                    <td
                      style={{ paddingTop: 24, whiteSpace: "nowrap" }}
                      className="rightAlign d-md-none d-xl-block"
                    >
                      2 KB
                    </td>
                    <td style={{ paddingTop: 24, textAlign: "right", paddingRight: 16 }}>
                      <a
                        href={"https://nexoid-data.s3.eu-west-1.amazonaws.com/agent/win/SilentCMD.exe.config"}
                        variant="contained"
                        className="rndButton"
                      >
                        Download
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Windows Silent Running</h2>
            </section>
            <section>
              <h3>Example 1 VBS:</h3>
              <p>This example runs NexoidAgent.exe silently in the background using VB Script.</p>
              <p>runme.vbs:</p>
              <div className="darkCode">
                <div>
                  CreateObject("Wscript.Shell").Run "<span className="jsonY">NexoidAgent.exe</span>", 0</div>
              </div>
            </section>
            <section>
              <h3>Example 2 PowerShell:</h3>
              <p>This example runs NexoidAgent.exe silently in the background using PowerShell and a Batch file.</p>
              <p>runme.bat:</p>
              <div className="darkCode">
                <div>
                  powershell -windowstyle hidden -command <span className="jsonY">./pscontainer.ps1</span>
                </div>
              </div>
              <p>pscontainer.ps1:</p>
              <div className="darkCode">
                <div>
                  Start-Process "<span className="jsonY">NexoidAgent.exe</span>" -NoNewWindow</div>
              </div>
            </section>
          </div>
        </div>
      </div >
    );
  }
}

export default Nexoid_Agent;



// WEBPACK FOOTER //
// ./src/components/knowlege/integration/Nexoid_Agent.js